import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/home/index'

Vue.use(VueRouter)

export default new VueRouter({
    routes: [{
        path: '/',
        name: 'Index',
        component: Index,
        meta: {
            title: '国星智能'
        }
    }
    ]
});